import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'

/**
 * Rooms restored from a reservation or bedbank cart item hold the service's room and rate ids.
 * A mandatory bundle rate is a clone of its hotel-only rate with the same service ids, so the
 * bundle tells the two apart.
 */
export function isServiceRateForRoom(rate: App.EnrichedPropertyRate, room: OfferPageRoom): boolean {
  const serviceRoomId = rate.service.type === 'lpc' ? rate.service.packageId : rate.service.roomId
  return serviceRoomId === room.roomId &&
    rate.service.rateId === room.rateId &&
    rate.bundle?.bundleId === room.bundleId
}

export function isRateForRoom(rate: App.EnrichedPropertyRate, room: OfferPageRoom): boolean {
  return (rate.roomId === room.roomId && rate.optionId === room.rateId) || isServiceRateForRoom(rate, room)
}
